import {
	COHORTS,
	useCohort,
	useIsJiraContactCompanyExpandEligible,
} from '@/components/user-context/helpers/cohorts';

import { LoggedInJiraNewUser } from '../components/logged-in-jira-new-user';

import { CurrentProductJoinableUser } from './current-product-joinable-user';
import { CurrentProductUser } from './current-product-user';
import { LoggedInJiraStandardExistingUser } from './existing-user';
import { LoggedInJiraStandardUpgradeEligibleUser } from './upgrade-eligible-user';

export const LoggedInJiraStandard = () => {
	const useContactExpandCohortLogic = useIsJiraContactCompanyExpandEligible();

	const cohort = useCohort(useContactExpandCohortLogic);

	if (useContactExpandCohortLogic) {
		if (cohort === COHORTS.CURRENT_PRODUCT_USER) {
			return <CurrentProductUser />;
		}

		if (cohort === COHORTS.CURRENT_PRODUCT_JOINABLE_USER) {
			return <CurrentProductJoinableUser />;
		}

		if (cohort === COHORTS.UPGRADE_ELIGIBLE_USER) {
			return <LoggedInJiraStandardUpgradeEligibleUser />;
		}

		return <LoggedInJiraNewUser />;
	}

	if (cohort === COHORTS.NEW_USER) {
		return <LoggedInJiraNewUser />;
	}

	if (cohort === COHORTS.UPGRADE_ELIGIBLE_USER) {
		return <LoggedInJiraStandardUpgradeEligibleUser />;
	}

	if (cohort) {
		return <LoggedInJiraStandardExistingUser />;
	}

	return null;
};
